import { enqueueSnackbar } from 'notistack'
import { useCallback } from 'react'

const useToastNotification = () => {
  const sendToastMessage = useCallback(
    (
      type: 'default' | 'error' | 'success' | 'warning' | 'info',
      message: string,
      duration?: number | 2000,
      persist?: boolean | false
    ) => {
      enqueueSnackbar(message, {
        variant: type,
        autoHideDuration: duration,
        preventDuplicate: true,
        persist: persist,
        style: { whiteSpace: 'pre-line' },
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
      })
    },
    []
  )

  const showApiErrorMessage = useCallback(
    (error: any, defaultMessage: string) => {
      let messageToShow = defaultMessage
      if (error.response && error.response.data) {
        const errorResponseData = error.response.data
        if (errorResponseData.detail) {
          messageToShow = errorResponseData.detail
        }

        if (errorResponseData.message) {
          messageToShow = errorResponseData.message
        }

        if (errorResponseData['hydra:description']) {
          if (
            errorResponseData['@type'] &&
            errorResponseData['@type'] === 'ConstraintViolationList'
          ) {
            if (errorResponseData['violations']) {
              messageToShow = errorResponseData['violations'][0].message
            } else {
              messageToShow =
                errorResponseData['hydra:description'].split(':')[1]
            }
          } else {
            messageToShow = errorResponseData['hydra:description']
          }
        }
      }

      sendToastMessage('error', messageToShow)
    },
    [sendToastMessage]
  )

  return { sendToastMessage, showApiErrorMessage }
}

export default useToastNotification
